var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"step-block"},[_c('div',{staticClass:"img-content"},[(_vm.getImgPath('switch-plan'))?_c('img',{staticClass:"item-icon",attrs:{"src":_vm.getImgPath('switch-plan'),"alt":"icon"}}):_vm._e()]),_c('div',{staticClass:"text"},[_vm._v(" "+_vm._s(_vm.$t("account.cancelSwitchPlanFull"))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }